export default [
  {
    "vaultsAddress": "0x937f5a2d9804125ba2783f6d86b4f80401ea5f4c",
    "depositTokenAddress": "0xf9845a03f7e6b06645a03a28b943c8a4b5fe7bcc",
    "matchedToken": {
      "address": "0xf9845a03f7e6b06645a03a28b943c8a4b5fe7bcc",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-beramo.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.aquabera.com/vault/0xf9845a03f7e6b06645a03a28b943c8a4b5fe7bcc",
      "name": "WBERA-BERAMO",
      "protocol": "aquabera",
      "symbol": "AB-KODIAK-WBERA-BERAMO-10000",
      "type": "amm"
    },
    "slug": "aquabera-wbera-beramo",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xdcf09e3ffdb42e388006e2dac54102f1006614c5",
    "depositTokenAddress": "0x04fd6a7b02e2e48caedad7135420604de5f834f8",
    "matchedToken": {
      "address": "0x04fd6a7b02e2e48caedad7135420604de5f834f8",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wbera-henlo.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.aquabera.com/vault/0x04fd6a7b02e2e48caedad7135420604de5f834f8",
      "name": "WBERA-HENLO",
      "protocol": "aquabera",
      "symbol": "AB-KODIAK-WBERA-HENLO-10000",
      "type": "amm"
    },
    "slug": "aquabera-wbera-henlo",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x81c78b2ca50e36c61885745e742d98e8490b6085",
    "depositTokenAddress": "0x62cf6e355c77edb6f5c8eb2085a85cf4de4c1852",
    "matchedToken": {
      "address": "0x62cf6e355c77edb6f5c8eb2085a85cf4de4c1852",
      "chainId": 80094,
      "decimals": 8,
      "displayPrecision": 8,
      "image": "/assets/tokens/bunibtc.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.beraborrow.com/den/borrow/unibtc",
      "name": "bUNIBTC",
      "protocol": "beraborrow",
      "symbol": "bUNIBTC",
      "type": "cdp"
    },
    "slug": "beraborrow-bunibtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xff14de98cc3d5677edd271d788604ca51677405a",
    "depositTokenAddress": "0x6751c09113a83a83a43829fd0b3bc0d7bdbe07bf",
    "matchedToken": {
      "address": "0x6751c09113a83a83a43829fd0b3bc0d7bdbe07bf",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/bwbera.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.beraborrow.com/den/borrow/wbera",
      "name": "bWBERA",
      "protocol": "beraborrow",
      "symbol": "bWBERA",
      "type": "cdp"
    },
    "slug": "beraborrow-bwbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xb751323d44ab4057fda58867e15eabe30b244ce1",
    "depositTokenAddress": "0x8628e618b66e7cddbe0adc84b96bea3977954507",
    "matchedToken": {
      "address": "0x8628e618b66e7cddbe0adc84b96bea3977954507",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/bwgbera.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.beraborrow.com/den/borrow/wgbera",
      "name": "bWGBERA",
      "protocol": "beraborrow",
      "symbol": "bWGBERA",
      "type": "cdp"
    },
    "slug": "beraborrow-bwgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5910e91c8586bf99d14434e6ad5ddb8e1f3aac1b",
    "depositTokenAddress": "0x597877ccf65be938bd214c4c46907669e3e62128",
    "matchedToken": {
      "address": "0x597877ccf65be938bd214c4c46907669e3e62128",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/snect.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.beraborrow.com/pool/deposit",
      "name": "sNECT",
      "protocol": "beraborrow",
      "symbol": "sNECT",
      "type": "cdp"
    },
    "slug": "beraborrow-snect",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x24f9e76a878ef11e8d9774b4c8dae5f04145cfca",
    "depositTokenAddress": "0xc857f2ba47b0560e0b8fcd4dd82b943b5ee88d2b",
    "matchedToken": {
      "address": "0xc857f2ba47b0560e0b8fcd4dd82b943b5ee88d2b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beradrome-henlocked100m.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0x926aa5f8eb3193f853711806d3f7df3deba99aaf",
      "name": "HENLOCKED100M",
      "protocol": "beradrome",
      "symbol": "Beradrome HENLOCKED100M",
      "type": "unknown"
    },
    "slug": "beradrome-henlocked100m",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5a838f4280a2096a77175b0b31385387afdd78c2",
    "depositTokenAddress": "0xfb32f8c7d363790a6ccd89f8d20047612aba633b",
    "matchedToken": {
      "address": "0xfb32f8c7d363790a6ccd89f8d20047612aba633b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beradrome-henlocked1b.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0x534b96f6f0b134a9fbb0eaa1881546dfb327b632",
      "name": "HENLOCKED1B",
      "protocol": "beradrome",
      "symbol": "Beradrome HENLOCKED1B",
      "type": "unknown"
    },
    "slug": "beradrome-henlocked1b",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x833378d7c4b9c219455007f3c8c8543be10136b1",
    "depositTokenAddress": "0x94ca1028ee60e5b28cda22c0e7b6743017a9b7b6",
    "matchedToken": {
      "address": "0x94ca1028ee60e5b28cda22c0e7b6743017a9b7b6",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beradrome-henlocked330m.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0xb6df86d016bb026f7dfd55a6a0361eab35ee2e7f",
      "name": "HENLOCKED330M",
      "protocol": "beradrome",
      "symbol": "Beradrome HENLOCKED330M",
      "type": "unknown"
    },
    "slug": "beradrome-henlocked330m",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xbe8418bf2ae9212dc948267c4b366e7e55654692",
    "depositTokenAddress": "0x94b12404d6163c3e49ed876fb25034a946a40dd8",
    "matchedToken": {
      "address": "0x94b12404d6163c3e49ed876fb25034a946a40dd8",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beradrome-henlocked420m.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0xe909901b40225959972554b0cebe460b4213d194",
      "name": "HENLOCKED420M",
      "protocol": "beradrome",
      "symbol": "Beradrome HENLOCKED420M",
      "type": "unknown"
    },
    "slug": "beradrome-henlocked420m",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x03b7c0969bdabbdb76f82232e1493ee1f2564d10",
    "depositTokenAddress": "0x872130ced110e2a4325693c0802b6a0112b3615b",
    "matchedToken": {
      "address": "0x872130ced110e2a4325693c0802b6a0112b3615b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beradrome-henlocked690m.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0xde67e60209a42d62bb1eba4878efc4b3b367c172",
      "name": "HENLOCKED690M",
      "protocol": "beradrome",
      "symbol": "Beradrome HENLOCKED690M",
      "type": "unknown"
    },
    "slug": "beradrome-henlocked690m",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xfa5cd98cb3475ff922ff43e774131a1303cf724c",
    "depositTokenAddress": "0xe8b92cd9771ebaad873a8e1b1b55404aecfdbc9d",
    "matchedToken": {
      "address": "0xe8b92cd9771ebaad873a8e1b1b55404aecfdbc9d",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/plug-wbera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0xaee71e1c9506f7a1fa6c7655657d239ebc31b5ae",
      "name": "PLUG-WBERA",
      "protocol": "beradrome",
      "symbol": "Beradrome Kodiak PLUG-WBERA-V2",
      "type": "unknown"
    },
    "slug": "beradrome-plug-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xa304d605668dd676bb13c4c72cdf5c2bec68d4fa",
    "depositTokenAddress": "0x36fa291f4a4ae41e4be2a979136ebd7eb97950e7",
    "matchedToken": {
      "address": "0x36fa291f4a4ae41e4be2a979136ebd7eb97950e7",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-locks.svg",
      "imageCount": 2,
      "isLpToken": true,
      "isSoulbound": true,
      "mintUrl": "https://www.beradrome.com/farms/0x74a38bfeedd95f65cbbf72eedf01eac77778bcf9",
      "name": "WBERA-LOCKS",
      "protocol": "beradrome",
      "symbol": "Beradrome Kodiak WBERA-LOCKS-V2",
      "type": "amm"
    },
    "slug": "beradrome-wbera-locks",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x43b30aa0c503541d2ba9153cc1270ab3bd0cb879",
    "depositTokenAddress": "0x53f786662ff5fbec135f913ab93c6b3366e90a46",
    "matchedToken": {
      "address": "0x53f786662ff5fbec135f913ab93c6b3366e90a46",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/asugar-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x53f786662ff5fbec135f913ab93c6b3366e90a4600020000000000000000014e/details",
      "name": "aSUGAR-HONEY",
      "protocol": "bex",
      "symbol": "50aSUGAR-50HONEY-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-asugar-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4ef8acfd3470b78079f235302c48e377016578b9",
    "depositTokenAddress": "0x5bc9c1c2a387b7048f915e30bc3aa7820c9c67c3",
    "matchedToken": {
      "address": "0x5bc9c1c2a387b7048f915e30bc3aa7820c9c67c3",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/ibera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x5bc9c1c2a387b7048f915e30bc3aa7820c9c67c3000000000000000000000152/details",
      "name": "iBERA-wgBERA",
      "protocol": "bex",
      "symbol": "iBERA-wgBERA-STABLE",
      "type": "amm"
    },
    "slug": "bex-ibera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8f1dd69e11d71b533fd14c3288163bec002cd2d3",
    "depositTokenAddress": "0x2a9ea10b60ab02e9b8960a08b4996e6bf5ea5eab",
    "matchedToken": {
      "address": "0x2a9ea10b60ab02e9b8960a08b4996e6bf5ea5eab",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/mead-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x2a9ea10b60ab02e9b8960a08b4996e6bf5ea5eab000000000000000000000162/details",
      "name": "MEAD-HONEY",
      "protocol": "bex",
      "symbol": "MEAD-HONEY-STABLE",
      "type": "amm"
    },
    "slug": "bex-mead-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x2b8a239e9f95d60ac49d4256018ab5dd5a01bfc2",
    "depositTokenAddress": "0x0af0aee92cd4f6b65fe22b2ca6a2c8862f3c6b9f",
    "matchedToken": {
      "address": "0x0af0aee92cd4f6b65fe22b2ca6a2c8862f3c6b9f",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/nect-bold-honey.svg",
      "imageCount": 3,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x0af0aee92cd4f6b65fe22b2ca6a2c8862f3c6b9f0000000000000000000001b5/details/",
      "name": "NECT-BOLD-HONEY",
      "protocol": "bex",
      "symbol": "NECT-BOLD-HONEY-STABLE",
      "type": "amm"
    },
    "slug": "bex-nect-bold-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x2d6c0464398a323756e7997edf6f18d7a8c5c09d",
    "depositTokenAddress": "0x7185e6cb1fcaf5d9e67af065b5e0fd8503e68be2",
    "matchedToken": {
      "address": "0x7185e6cb1fcaf5d9e67af065b5e0fd8503e68be2",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/swbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x7185e6cb1fcaf5d9e67af065b5e0fd8503e68be2000200000000000000000198/details/",
      "name": "sWBERA-wgBERA (20/80)",
      "protocol": "bex",
      "symbol": "20sWBERA-80wgBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-swbera-wgbera-20-80",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x45f31b4141e40ce298ff9b38fa87b9ae168cb977",
    "depositTokenAddress": "0xe9b91292fc29753a723ded3574f3ad8ec77d08dc",
    "matchedToken": {
      "address": "0xe9b91292fc29753a723ded3574f3ad8ec77d08dc",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/swbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0xe9b91292fc29753a723ded3574f3ad8ec77d08dc00020000000000000000019a/details/",
      "name": "sWBERA-wgBERA (80/20)",
      "protocol": "bex",
      "symbol": "80sWBERA-20wgBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-swbera-wgbera-80-20",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x1419515d3703d8f2cc72fa6a341685e4f8e7e8e1",
    "depositTokenAddress": "0xf961a8f6d8c69e7321e78d254ecafbcc3a637621",
    "matchedToken": {
      "address": "0xf961a8f6d8c69e7321e78d254ecafbcc3a637621",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/usdc-e-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0xf961a8f6d8c69e7321e78d254ecafbcc3a637621000000000000000000000001/details",
      "name": "USDC.e-HONEY",
      "protocol": "bex",
      "symbol": "USDC.e-HONEY-STABLE",
      "type": "amm"
    },
    "slug": "bex-usdc.e-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xf216ab07ec86086bdeeb89f8c430958464f4fa69",
    "depositTokenAddress": "0x2461e93d5963c2bb69de499676763e67a63c7ba5",
    "matchedToken": {
      "address": "0x2461e93d5963c2bb69de499676763e67a63c7ba5",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wbera-dinero.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x2461e93d5963c2bb69de499676763e67a63c7ba50002000000000000000000c2/details",
      "name": "WBERA-DINERO",
      "protocol": "bex",
      "symbol": "80DINERO-20WBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wbera-dinero",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xe2d8941dfb85435419d90397b09d18024ebeef2c",
    "depositTokenAddress": "0x2c4a603a2aa5596287a06886862dc29d56dbc354",
    "matchedToken": {
      "address": "0x2c4a603a2aa5596287a06886862dc29d56dbc354",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/wbera-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x2c4a603a2aa5596287a06886862dc29d56dbc354000200000000000000000002/details",
      "name": "WBERA-HONEY",
      "protocol": "bex",
      "symbol": "50WBERA-50HONEY-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wbera-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd3d50fe6dbbb452ed30c7736d70678e4e0d277c8",
    "depositTokenAddress": "0x62c030b29a6fef1b32677499e4a1f1852a8808c0",
    "matchedToken": {
      "address": "0x62c030b29a6fef1b32677499e4a1f1852a8808c0",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-ibera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x62c030b29a6fef1b32677499e4a1f1852a8808c00000000000000000000000c6/details",
      "name": "WBERA-iBERA",
      "protocol": "bex",
      "symbol": "WBERA-iBERA-STABLE",
      "type": "amm"
    },
    "slug": "bex-wbera-ibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xa2330be60ea1f34bb7cc116730fdb00214820350",
    "depositTokenAddress": "0x705fc16ba5a1eb67051934f2fb17eacae660f6c7",
    "matchedToken": {
      "address": "0x705fc16ba5a1eb67051934f2fb17eacae660f6c7",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-lbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x705fc16ba5a1eb67051934f2fb17eacae660f6c70002000000000000000000d5/details",
      "name": "WBERA-LBGT",
      "protocol": "bex",
      "symbol": "50WBERA-50LBGT-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wbera-lbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x78beda3a06443f51718d746ade95b5fac094633e",
    "depositTokenAddress": "0x38fdd999fe8783037db1bbfe465759e312f2d809",
    "matchedToken": {
      "address": "0x38fdd999fe8783037db1bbfe465759e312f2d809",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-wbtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x38fdd999fe8783037db1bbfe465759e312f2d809000200000000000000000004/details",
      "name": "WBERA-WBTC",
      "protocol": "bex",
      "symbol": "50WBTC-50WBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wbera-wbtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x0df14916796854d899576cbde69a35bafb923c22",
    "depositTokenAddress": "0xdd70a5ef7d8cfe5c5134b5f9874b09fb5ce812b4",
    "matchedToken": {
      "address": "0xdd70a5ef7d8cfe5c5134b5f9874b09fb5ce812b4",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-weth.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0xdd70a5ef7d8cfe5c5134b5f9874b09fb5ce812b4000200000000000000000003/details",
      "name": "WBERA-WETH",
      "protocol": "bex",
      "symbol": "50WETH-50WBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wbera-weth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xdec4d737680b8c3f3faa507b2af78bf85d74a48e",
    "depositTokenAddress": "0x258d8933b625566fbe057874121783a2808adafa",
    "matchedToken": {
      "address": "0x258d8933b625566fbe057874121783a2808adafa",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 4,
      "image": "/assets/tokens/weth-beraeth.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x258d8933b625566fbe057874121783a2808adafa0000000000000000000000c1/details",
      "name": "WETH-beraETH",
      "protocol": "bex",
      "symbol": "WETH-beraETH-STABLE",
      "type": "amm"
    },
    "slug": "bex-weth-beraeth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x7fbecbb6a80bed02553b98c2016e7a1b598c90af",
    "depositTokenAddress": "0x8f32c1b7c9e2c60d357b7949a43540162248a21e",
    "matchedToken": {
      "address": "0x8f32c1b7c9e2c60d357b7949a43540162248a21e",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wgbera-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x8f32c1b7c9e2c60d357b7949a43540162248a21e00000000000000000000014a/details/",
      "name": "wgBERA-WBERA",
      "protocol": "bex",
      "symbol": "wgBERA-WBERA-STABLE",
      "type": "amm"
    },
    "slug": "bex-wgbera-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x7040a4923ea90e84a2b362bdb08ec481789b0e2b",
    "depositTokenAddress": "0x1b7b061091bd2c900723107889fe44f825d6c921",
    "matchedToken": {
      "address": "0x1b7b061091bd2c900723107889fe44f825d6c921",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wizz-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x1b7b061091bd2c900723107889fe44f825d6c92100020000000000000000010c/details",
      "name": "WIZZ-WBERA",
      "protocol": "bex",
      "symbol": "50WIZZ-50WBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "bex-wizz-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xb28339e9e78a73d08fc689ccc44e4e71810004c9",
    "depositTokenAddress": "0xb5d46214f4ec7f910cb433e412d32ee817986e90",
    "matchedToken": {
      "address": "0xb5d46214f4ec7f910cb433e412d32ee817986e90",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://www.bulla.exchange/vault/details/wbera-honey-narrow",
      "name": "WBERA-HONEY",
      "protocol": "bulla",
      "symbol": "aWBERA-HONEY",
      "type": "amm"
    },
    "slug": "bulla-wbera-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4c73391906f168fe2fd2b7a2744ca81920015688",
    "depositTokenAddress": "0xcffbfd665bedb19b47837461a5abf4388c560d35",
    "matchedToken": {
      "address": "0xcffbfd665bedb19b47837461a5abf4388c560d35",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-ibgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://www.bulla.exchange/vault/details/wbera-ibgt-narrow",
      "name": "WBERA-iBGT",
      "protocol": "bulla",
      "symbol": "aWBERA-iBGT",
      "type": "amm"
    },
    "slug": "bulla-wbera-ibgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xacef07f40cb42dfe88e40b166f51c7094351f9ee",
    "depositTokenAddress": "0xddd3ea5de9c70973e224d938b8f392ec4cc0171c",
    "matchedToken": {
      "address": "0xddd3ea5de9c70973e224d938b8f392ec4cc0171c",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/bull-ish-v2.svg",
      "isLpToken": false,
      "isSoulbound": true,
      "isUnpriced": true,
      "mintUrl": "https://game.bullas.xyz",
      "name": "BULL ISH V2",
      "protocol": "bullish",
      "symbol": "BULL ISH V2",
      "type": "points"
    },
    "slug": "bullish-bull-ish-v2",
    "rewardTokens": []
  },
  {
    "vaultsAddress": "0xf4c0ed37fdd387013812bbfc6a0698a73ec5fe47",
    "depositTokenAddress": "0xc4c039178a79e614609e592d7689ecb3107758b1",
    "matchedToken": {
      "address": "0xc4c039178a79e614609e592d7689ecb3107758b1",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/burr-nect.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xc4c039178a79e614609e592d7689ecb3107758b1000200000000000000000020/add-liquidity",
      "name": "BURR-NECT",
      "protocol": "burrbear",
      "symbol": "20NECT-80BURR",
      "type": "amm"
    },
    "slug": "burrbear-burr-nect",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xdead3ba864882025d9c7d2ae51dacc6fc23e5eb1",
    "depositTokenAddress": "0xac8a437d1e6905e419431662aead90fb04ac3008",
    "matchedToken": {
      "address": "0xac8a437d1e6905e419431662aead90fb04ac3008",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/burr-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xac8a437d1e6905e419431662aead90fb04ac300800020000000000000000000f/add-liquidity",
      "name": "BURR-wgBERA",
      "protocol": "burrbear",
      "symbol": "80BURR-20wgBERA",
      "type": "amm"
    },
    "slug": "burrbear-burr-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x43398f20336e0bc2c2d07c819844cc736d6e6ee0",
    "depositTokenAddress": "0x7ce7cb1893cfbd680cbfb9dd2a9ae6a62bde66a8",
    "matchedToken": {
      "address": "0x7ce7cb1893cfbd680cbfb9dd2a9ae6a62bde66a8",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/ibgt-lbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0x7ce7cb1893cfbd680cbfb9dd2a9ae6a62bde66a800000000000000000000000d/add-liquidity",
      "name": "iBGT-LBGT",
      "protocol": "burrbear",
      "symbol": "iBGT-LBGT",
      "type": "amm"
    },
    "slug": "burrbear-ibgt-lbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x12e9b82f3280cc32e81b865f85734d52c538314c",
    "depositTokenAddress": "0xd170e25f6bcb5ace2108628c647be47d59900ade",
    "matchedToken": {
      "address": "0xd170e25f6bcb5ace2108628c647be47d59900ade",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/nect-plug.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xd170e25f6bcb5ace2108628c647be47d59900ade00020000000000000000000c/add-liquidity",
      "name": "NECT-PLUG",
      "protocol": "burrbear",
      "symbol": "50NECT-50PLUG",
      "type": "amm"
    },
    "slug": "burrbear-nect-plug",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4a7870ac8d2937fd5a73ba0e530e6d9918011372",
    "depositTokenAddress": "0xd10e65a5f8ca6f835f2b1832e37cf150fb955f23",
    "matchedToken": {
      "address": "0xd10e65a5f8ca6f835f2b1832e37cf150fb955f23",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/nect-usdc-e-honey.svg",
      "imageCount": 3,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xd10e65a5f8ca6f835f2b1832e37cf150fb955f23000000000000000000000004/add-liquidity",
      "name": "NECT-USDC.e-HONEY",
      "protocol": "burrbear",
      "symbol": "NECT/USDC/HONEY",
      "type": "amm"
    },
    "slug": "burrbear-nect-usdc.e-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x95c9dabc4e83f8e6b30437293e48062daf1837d7",
    "depositTokenAddress": "0xb34fca9739249578d93a22ce02bf7fad277bad35",
    "matchedToken": {
      "address": "0xb34fca9739249578d93a22ce02bf7fad277bad35",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/nect-usdc-e-usdt0-honey.svg",
      "imageCount": 4,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xb34fca9739249578d93a22ce02bf7fad277bad35000000000000000000000013/add-liquidity",
      "name": "NECT-USDC.e-USD₮0-HONEY",
      "protocol": "burrbear",
      "symbol": "NECT-USDC.e-USD₮0-HONEY",
      "type": "amm"
    },
    "slug": "burrbear-nect-usdc.e-usd₮0-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x7d6946649e1944839d237d7a2c91d4c5c1ebb16b",
    "depositTokenAddress": "0xe416c064946112c1626d6700d1081a750b1b1dd7",
    "matchedToken": {
      "address": "0xe416c064946112c1626d6700d1081a750b1b1dd7",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/nect-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xe416c064946112c1626d6700d1081a750b1b1dd7000200000000000000000008/add-liquidity",
      "name": "NECT-wgBERA",
      "protocol": "burrbear",
      "symbol": "50NECT-50wgBERA",
      "type": "amm"
    },
    "slug": "burrbear-nect-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x47b62bfc7aa8927e1a587f077dfb5b1e169baeab",
    "depositTokenAddress": "0x567f32e86be3e3963cdbc1887b5043b701f113d9",
    "matchedToken": {
      "address": "0x567f32e86be3e3963cdbc1887b5043b701f113d9",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0x567f32e86be3e3963cdbc1887b5043b701f113d9000000000000000000000006/add-liquidity",
      "name": "WBERA-wgBERA",
      "protocol": "burrbear",
      "symbol": "WBERA-wgBERA",
      "type": "amm"
    },
    "slug": "burrbear-wbera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x50636ba225bea3b9e75220a89e20ca1e9cdaeec8",
    "depositTokenAddress": "0xcbef1b65399065c2de2c495971e90466ff38f2d0",
    "matchedToken": {
      "address": "0xcbef1b65399065c2de2c495971e90466ff38f2d0",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-solvbtc-xsolvbtc.svg",
      "imageCount": 3,
      "isLpToken": true,
      "mintUrl": "https://app.burrbear.io/#/berachain/pool/0xcbef1b65399065c2de2c495971e90466ff38f2d000000000000000000000001e/add-liquidity",
      "name": "WBTC-SolvBTC-xSolvBTC",
      "protocol": "burrbear",
      "symbol": "WBTC/solvBTC/xSolvBTC",
      "type": "amm"
    },
    "slug": "burrbear-wbtc-solvbtc-xsolvbtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xf3116662717b199ec9b44f119dc1ae2eb5d9ea7d",
    "depositTokenAddress": "0xbe75c8a7e58c7901d2e128dc8d3b6de2481f1f79",
    "matchedToken": {
      "address": "0xbe75c8a7e58c7901d2e128dc8d3b6de2481f1f79",
      "chainId": 80094,
      "decimals": 6,
      "displayPrecision": 2,
      "image": "/assets/tokens/dgnberaland.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://d2.finance/strategies/dgnberaland?chainid=80094&tab=2",
      "name": "dgnBeraland",
      "protocol": "d2finance",
      "symbol": "dgnBeraland",
      "type": "vault"
    },
    "slug": "d2finance-dgnberaland",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x55f7fe5ba46085673a80fa6a01996405486f88eb",
    "depositTokenAddress": "0x36b933554782b108bb9962ac00c498acbceb706d",
    "matchedToken": {
      "address": "0x36b933554782b108bb9962ac00c498acbceb706d",
      "chainId": 80094,
      "decimals": 6,
      "displayPrecision": 2,
      "image": "/assets/tokens/hyperbera-usdc.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://d2.finance/strategies/hyperbera.usdc?chainid=80094&tab=1",
      "name": "USDC.e",
      "protocol": "d2finance",
      "symbol": "HyperBERA.USDC",
      "type": "vault"
    },
    "slug": "d2finance-usdc.e",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xea7844869097ed447bf57d85b24142c21694e805",
    "depositTokenAddress": "0x26bbc26415c6316890565f5f73017f85ee70b60c",
    "matchedToken": {
      "address": "0x26bbc26415c6316890565f5f73017f85ee70b60c",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/dbusd.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isDepositDisabled": true,
      "isLpToken": true,
      "mintUrl": "https://app.madhoney.fi/vault",
      "name": "dbUSD",
      "protocol": "d8x",
      "symbol": "dbUSD",
      "type": "perpetuals"
    },
    "slug": "d8x-dbusd",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xb3adfa77f96cc111ac3d4817b0cf096e0ec01ae5",
    "depositTokenAddress": "0x7f2b60fdff1494a0e3e060532c9980d7fad0404b",
    "matchedToken": {
      "address": "0x7f2b60fdff1494a0e3e060532c9980d7fad0404b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/dhoney.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.dolomite.io/balances",
      "name": "dHONEY",
      "protocol": "dolomite",
      "symbol": "dHONEY",
      "type": "cdp"
    },
    "slug": "dolomite-dhoney",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x86a399b793699e101f0b3c8e917cb39a2f8fa312",
    "depositTokenAddress": "0x3000c6bf0aaeb813e252b584c4d9a82f99e7a71d",
    "matchedToken": {
      "address": "0x3000c6bf0aaeb813e252b584c4d9a82f99e7a71d",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/drusd.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.dolomite.io/balances",
      "name": "drUSD",
      "protocol": "dolomite",
      "symbol": "drUSD",
      "type": "cdp"
    },
    "slug": "dolomite-drusd",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x62e63d88cd6074d2c601e40deec439a63151e879",
    "depositTokenAddress": "0xaa97d791afc02af30cf0b046172bb05b3c306517",
    "matchedToken": {
      "address": "0xaa97d791afc02af30cf0b046172bb05b3c306517",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/dwbera.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.dolomite.io/balances",
      "name": "dWBERA",
      "protocol": "dolomite",
      "symbol": "dWBERA",
      "type": "cdp"
    },
    "slug": "dolomite-dwbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8cab8b24fa2c69df228778ecf605cc2078be36cb",
    "depositTokenAddress": "0xf7b5127b510e568fdc39e6bb54e2081bfad489af",
    "matchedToken": {
      "address": "0xf7b5127b510e568fdc39e6bb54e2081bfad489af",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 4,
      "image": "/assets/tokens/dweth.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.dolomite.io/balances",
      "name": "dWETH",
      "protocol": "dolomite",
      "symbol": "dWETH",
      "type": "cdp"
    },
    "slug": "dolomite-dweth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4ba0a69621ea72870f9fcf2d974d39b8609343cc",
    "depositTokenAddress": "0x46fcd35431f5b371224acc2e2e91732867b1a77e",
    "matchedToken": {
      "address": "0x46fcd35431f5b371224acc2e2e91732867b1a77e",
      "chainId": 80094,
      "decimals": 8,
      "displayPrecision": 8,
      "image": "/assets/tokens/primeliquidberabtc.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isDepositDisabled": true,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "mintUrl": "https://www.ether.fi/app/liquid/bera-btc",
      "name": "primeLiquidBeraBTC",
      "protocol": "etherfi",
      "symbol": "primeLiquidBeraBTC",
      "type": "vault"
    },
    "slug": "etherfi-primeliquidberabtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xc9d8bc7428059219f3d19da7f17ad468254d4d7e",
    "depositTokenAddress": "0xb83742330443f7413dbd2abdfc046db0474a944e",
    "matchedToken": {
      "address": "0xb83742330443f7413dbd2abdfc046db0474a944e",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 4,
      "image": "/assets/tokens/primeliquidberaeth.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isDepositDisabled": true,
      "isLpToken": false,
      "isNotWorkingWithEnso": true,
      "mintUrl": "https://www.ether.fi/app/liquid/bera-eth",
      "name": "primeLiquidBeraETH",
      "protocol": "etherfi",
      "symbol": "primeLiquidBeraETH",
      "type": "vault"
    },
    "slug": "etherfi-primeliquidberaeth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x7562675fcc4df8ef2e422c0e1eb1f51d148f9a54",
    "depositTokenAddress": "0x112b77a77753b092306b1c04bd70215fed4e00a1",
    "matchedToken": {
      "address": "0x112b77a77753b092306b1c04bd70215fed4e00a1",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/enect-1.svg",
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.euler.finance/vault/0x112b77a77753b092306b1c04bd70215fed4e00a1?network=berachain",
      "name": "eNECT",
      "protocol": "euler",
      "symbol": "eNECT-1",
      "type": "vault"
    },
    "slug": "euler-enect",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xdfa78fba828fbde043bc50e88c7ba30e647fa2fc",
    "depositTokenAddress": "0x6ee01549960f47b2e64cb9fb26a9107e735910b5",
    "matchedToken": {
      "address": "0x6ee01549960f47b2e64cb9fb26a9107e735910b5",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/very-awesome-unified-liquidity-token.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isSoulbound": true,
      "mintUrl": "https://honeypotfinance.xyz",
      "name": "Very Awesome Unified Liquidity Token",
      "protocol": "honeypot",
      "symbol": "VAULT",
      "type": "unknown"
    },
    "slug": "honeypot-very-awesome-unified-liquidity-token",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x75f3be06b02e235f6d0e7ef2d462b29739168301",
    "depositTokenAddress": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
    "matchedToken": {
      "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/ibgt.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://infrared.finance/ibgt",
      "name": "iBGT",
      "protocol": "infrared",
      "symbol": "iBGT",
      "type": "vault"
    },
    "slug": "infrared-ibgt",
    "rewardTokens": [
      // {
      //   "address": "0xfcbd14dc51f0a4d49d5e53c2e0950e0bc26d0dce",
      //   "chainId": 80094,
      //   "decimals": 18,
      //   "displayPrecision": 2,
      //   "image": "/assets/tokens/honey.svg",
      //   "isLpToken": false,
      //   "name": "HONEY",
      //   "symbol": "HONEY"
      // },
      // {
      //   "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
      //   "chainId": 80094,
      //   "decimals": 18,
      //   "displayPrecision": 3,
      //   "image": "/assets/tokens/ibgt.svg",
      //   "isLpToken": false,
      //   "name": "iBGT",
      //   "symbol": "iBGT"
      // },
      {
        "address": "0x6969696969696969696969696969696969696969",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/wbera.svg",
        "isLpToken": false,
        "name": "WBERA",
        "symbol": "WBERA"
      },
      {
        "address": "0x4f3c10d2bc480638048fa67a7d00237a33670c1b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/wibgt.svg",
        "isLpToken": false,
        "name": "wiBGT",
        "symbol": "wiBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x61ace3fdee1f0fc58027adf4bd16cbf20e447437",
    "depositTokenAddress": "0x57161d6272f47cd48ba165646c802f001040c2e0",
    "matchedToken": {
      "address": "0x57161d6272f47cd48ba165646c802f001040c2e0",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/beraeth-stone.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x57161d6272f47cd48ba165646c802f001040c2e0?chain=berachain_mainnet",
      "name": "beraETH-STONE",
      "protocol": "kodiak",
      "symbol": "KODI beraETH-STONE",
      "type": "amm"
    },
    "slug": "kodiak-beraeth-stone",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8c85f1e4ffddc36a2b4d512720fd78769f715fa9",
    "depositTokenAddress": "0x7aef016302c3a27417372cf3aa74a1708d1ca291",
    "matchedToken": {
      "address": "0x7aef016302c3a27417372cf3aa74a1708d1ca291",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/beramo-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x7aef016302c3a27417372cf3aa74a1708d1ca291?chain=berachain_mainnet",
      "name": "BERAMO-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI BERAMO-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-beramo-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x7a548f57d1e144f14b0f0e1cfef5371c549619fb",
    "depositTokenAddress": "0xe454c546c8f3875e928910abc653de5f8c432f11",
    "matchedToken": {
      "address": "0xe454c546c8f3875e928910abc653de5f8c432f11",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/bixbt-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xe454c546c8f3875e928910abc653de5f8c432f11?chain=berachain_mainnet",
      "name": "BIXBT-WBERA",
      "protocol": "kodiak",
      "symbol": "UNI-V2",
      "type": "amm"
    },
    "slug": "kodiak-bixbt-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd2d46c07c32236e7bdaff782518b200342f12a58",
    "depositTokenAddress": "0x0fd67ac75f9df51f5d81f582417b318f44b45f5c",
    "matchedToken": {
      "address": "0x0fd67ac75f9df51f5d81f582417b318f44b45f5c",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/bm-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x0fd67ac75f9df51f5d81f582417b318f44b45f5c?chain=berachain_mainnet",
      "name": "bm-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-bm",
      "type": "amm"
    },
    "slug": "kodiak-bm-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xc12d6d079896811ccbb837ffbe335605757d3853",
    "depositTokenAddress": "0x1ac0e38ee5f66f6fa46e1644bb6b73bee598b953",
    "matchedToken": {
      "address": "0x1ac0e38ee5f66f6fa46e1644bb6b73bee598b953",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/brbtc-unibtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x1ac0e38ee5f66f6fa46e1644bb6b73bee598b953?chain=berachain_mainnet",
      "name": "brBTC-uniBTC",
      "protocol": "kodiak",
      "symbol": "KODI brBTC-uniBTC",
      "type": "amm"
    },
    "slug": "kodiak-brbtc-unibtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xe51b93e4031bdd9cf903ea5a9299c50f0db5d978",
    "depositTokenAddress": "0x54c603173ca92a42b81f8838d705fd3e0f98d5d4",
    "matchedToken": {
      "address": "0x54c603173ca92a42b81f8838d705fd3e0f98d5d4",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/bread-lbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x54c603173ca92a42b81f8838d705fd3e0f98d5d4?chain=berachain_mainnet",
      "name": "BREAD-LBGT",
      "protocol": "kodiak",
      "symbol": "KODI BREAD-LBGT",
      "type": "amm"
    },
    "slug": "kodiak-bread-lbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8e814168bb53695edac6a370a55db036dd7bb39b",
    "depositTokenAddress": "0xd9a747880393f7c33cef1aea36909b36d421f7e5",
    "matchedToken": {
      "address": "0xd9a747880393f7c33cef1aea36909b36d421f7e5",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/bread-ohm.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xd9a747880393f7c33cef1aea36909b36d421f7e5?chain=berachain_mainnet",
      "name": "BREAD-OHM",
      "protocol": "kodiak",
      "symbol": "KODI BREAD-OHM",
      "type": "amm"
    },
    "slug": "kodiak-bread-ohm",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xa23701e0554b4d519e7da177901c46217cb35cf4",
    "depositTokenAddress": "0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa",
    "matchedToken": {
      "address": "0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/dolo-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa?chain=berachain_mainnet",
      "name": "DOLO-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI DOLO-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-dolo-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xef0d7f79f2f9693c8b76e93d0490d479db089f19",
    "depositTokenAddress": "0x0b77545a4eb1b995e79bf85e0ed8d6ee288ca632",
    "matchedToken": {
      "address": "0x0b77545a4eb1b995e79bf85e0ed8d6ee288ca632",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ewbera-4-osbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x0b77545a4eb1b995e79bf85e0ed8d6ee288ca632?chain=berachain_mainnet",
      "name": "eWBERA-4-osBGT",
      "protocol": "kodiak",
      "symbol": "KODI eWBERA-4-osBGT",
      "type": "amm"
    },
    "slug": "kodiak-ewbera-4-osbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8e6993b4bb8321319fe380f0967b76c0c213c891",
    "depositTokenAddress": "0x2a6f7008a884563df6fbf2d7676e696a44bb8896",
    "matchedToken": {
      "address": "0x2a6f7008a884563df6fbf2d7676e696a44bb8896",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/hohm-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x2a6f7008a884563df6fbf2d7676e696a44bb8896?chain=berachain_mainnet",
      "name": "hOHM-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI hOHM-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-hohm-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8bd2010e1193a96de1c5f6f647a5b2717b0c4f9b",
    "depositTokenAddress": "0xdca120bd3a13250b67f6faa5c29c1f38ec6ebece",
    "matchedToken": {
      "address": "0xdca120bd3a13250b67f6faa5c29c1f38ec6ebece",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/hold-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xdca120bd3a13250b67f6faa5c29c1f38ec6ebece?chain=berachain_mainnet",
      "name": "HOLD-WBERA",
      "protocol": "kodiak",
      "symbol": "UNI-V2",
      "type": "amm"
    },
    "slug": "kodiak-hold-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xe5c36544c295e88c37024736cef3a46e40650542",
    "depositTokenAddress": "0x24afceb372b755f4953e738d6b38e9e4646d9f57",
    "matchedToken": {
      "address": "0x24afceb372b755f4953e738d6b38e9e4646d9f57",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ibera-ibgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x24afceb372b755f4953e738d6b38e9e4646d9f57?chain=berachain_mainnet",
      "name": "iBERA-iBGT",
      "protocol": "kodiak",
      "symbol": "KODI iBERA-iBGT",
      "type": "amm"
    },
    "slug": "kodiak-ibera-ibgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x6474abddb2eea8f070fd520c4b9f72d3c6f9c1e8",
    "depositTokenAddress": "0xad445256ff81171043a5e7cd8831e4371b000176",
    "matchedToken": {
      "address": "0xad445256ff81171043a5e7cd8831e4371b000176",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ibera-osbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xad445256ff81171043a5e7cd8831e4371b000176?chain=berachain_mainnet",
      "name": "iBERA-osBGT",
      "protocol": "kodiak",
      "symbol": "KODI iBERA-osBGT",
      "type": "amm"
    },
    "slug": "kodiak-ibera-osbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x9329f5696f4326e3b3dc1c6c724ad6e91e17124f",
    "depositTokenAddress": "0x88c983bf3d4a9adcee14e1b4f1c446c4c5853ea3",
    "matchedToken": {
      "address": "0x88c983bf3d4a9adcee14e1b4f1c446c4c5853ea3",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/ibera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x88c983bf3d4a9adcee14e1b4f1c446c4c5853ea3?chain=berachain_mainnet",
      "name": "iBERA-wgBERA",
      "protocol": "kodiak",
      "symbol": "KODI iBERA-wgBERA",
      "type": "amm"
    },
    "slug": "kodiak-ibera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x21f6aefb35fc370b53a4efa386e23f21478c1dd6",
    "depositTokenAddress": "0x5d3da311a5d3c22d257bb9943de9e55acda2f9cf",
    "matchedToken": {
      "address": "0x5d3da311a5d3c22d257bb9943de9e55acda2f9cf",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/mbgt-ibera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x5d3da311a5d3c22d257bb9943de9e55acda2f9cf?chain=berachain_mainnet",
      "name": "mBGT-iBERA",
      "protocol": "kodiak",
      "symbol": "KODI mBGT-iBERA",
      "type": "amm"
    },
    "slug": "kodiak-mbgt-ibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x19a13d1855b6ed39edf1e3a8343ae8cffecdf498",
    "depositTokenAddress": "0xef8c3239e0d8be9d58f145e18f5909ddad681365",
    "matchedToken": {
      "address": "0xef8c3239e0d8be9d58f145e18f5909ddad681365",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/nav-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xef8c3239e0d8be9d58f145e18f5909ddad681365?chain=berachain_mainnet",
      "name": "NAV-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI NAV-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-nav-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x446ac05420abc9fbe90646750df14fee2bae3d6d",
    "depositTokenAddress": "0x8ef48ae9df6165acc9754297bf28f5877c229c03",
    "matchedToken": {
      "address": "0x8ef48ae9df6165acc9754297bf28f5877c229c03",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/nect-usdt0.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x8ef48ae9df6165acc9754297bf28f5877c229c03?chain=berachain_mainnet",
      "name": "NECT-USD₮0",
      "protocol": "kodiak",
      "symbol": "KODI NECT-USD₮0",
      "type": "amm"
    },
    "slug": "kodiak-nect-usd₮0",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xa57cb177beebc35a1a26a286951a306d9b752524",
    "depositTokenAddress": "0x98bdeede9a45c28d229285d9d6e9139e9f505391",
    "matchedToken": {
      "address": "0x98bdeede9a45c28d229285d9d6e9139e9f505391",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/ohm-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x98bdeede9a45c28d229285d9d6e9139e9f505391?chain=berachain_mainnet",
      "name": "OHM-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI OHM-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-ohm-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x14f8730771da7fa3fe287230a4e74bda3ad6349c",
    "depositTokenAddress": "0xc227c8639a41db8393dd1b4eac41464a62d64fb4",
    "matchedToken": {
      "address": "0xc227c8639a41db8393dd1b4eac41464a62d64fb4",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/ohm-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xc227c8639a41db8393dd1b4eac41464a62d64fb4?chain=berachain_mainnet",
      "name": "OHM-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI OHM-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-ohm-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xabbd242421ed0c31b3c0c428f49dffb73fbd78ec",
    "depositTokenAddress": "0x9b155cf7a4e5911ac35ab2173d0f58e1d39570fd",
    "matchedToken": {
      "address": "0x9b155cf7a4e5911ac35ab2173d0f58e1d39570fd",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/ooga-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x9b155cf7a4e5911ac35ab2173d0f58e1d39570fd?chain=berachain_mainnet",
      "name": "OOGA-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI OOGA-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-ooga-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd2d7700c88e4a9254c57821f6a722304a6390c20",
    "depositTokenAddress": "0xe38e2273df9ca6f2cd6f2ea0b13399e65bf799f1",
    "matchedToken": {
      "address": "0xe38e2273df9ca6f2cd6f2ea0b13399e65bf799f1",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/plutus-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xe38e2273df9ca6f2cd6f2ea0b13399e65bf799f1?chain=berachain_mainnet",
      "name": "PLUTUS-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI PLUTUS-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-plutus-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x1c5879b75be9e817b1607afb6f24f632ee6f8820",
    "depositTokenAddress": "0x7fd165b73775884a38aa8f2b384a53a3ca7400e6",
    "matchedToken": {
      "address": "0x7fd165b73775884a38aa8f2b384a53a3ca7400e6",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/rusd-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x7fd165b73775884a38aa8f2b384a53a3ca7400e6?chain=berachain_mainnet",
      "name": "rUSD-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI rUSD-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-rusd-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xe3d07819010444db16c86ef3d591d2d4116f3b1b",
    "depositTokenAddress": "0x1fb6c1ade4f9083b2ea42ed3fa9342e41788d4b5",
    "matchedToken": {
      "address": "0x1fb6c1ade4f9083b2ea42ed3fa9342e41788d4b5",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/rusd-usdt0.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x1fb6c1ade4f9083b2ea42ed3fa9342e41788d4b5?chain=berachain_mainnet",
      "name": "rUSD-USD₮0",
      "protocol": "kodiak",
      "symbol": "KODI rUSD-USD₮0",
      "type": "amm"
    },
    "slug": "kodiak-rusd-usd₮0",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xb706af0babbe38ec4c7d897c3182c1d301491bda",
    "depositTokenAddress": "0x4d1b02ff3ce55b816bb916ad8f80479434830ea4",
    "matchedToken": {
      "address": "0x4d1b02ff3ce55b816bb916ad8f80479434830ea4",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/sol-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x4d1b02ff3ce55b816bb916ad8f80479434830ea4?chain=berachain_mainnet",
      "name": "SOL-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI SOL-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-sol-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd844acf04d101e78de2d32813956fa9104ad48fc",
    "depositTokenAddress": "0x43e487126c4f37d1915cf02a90b5c5295afb1790",
    "matchedToken": {
      "address": "0x43e487126c4f37d1915cf02a90b5c5295afb1790",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 5,
      "image": "/assets/tokens/solvbtc-xsolvbtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x43e487126c4f37d1915cf02a90b5c5295afb1790?chain=berachain_mainnet",
      "name": "SolvBTC-xSolvBTC",
      "protocol": "kodiak",
      "symbol": "KODI SolvBTC-SolvBTC.BBN",
      "type": "amm"
    },
    "slug": "kodiak-solvbtc-xsolvbtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xf5d2d7e7d8e1523b728715bb4065523ac1c47104",
    "depositTokenAddress": "0xc60ea9801b3f1b01da373c05381e6ce8ff94d76f",
    "matchedToken": {
      "address": "0xc60ea9801b3f1b01da373c05381e6ce8ff94d76f",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 7,
      "image": "/assets/tokens/solvbtc-bnb-solvbtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.02,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xc60ea9801b3f1b01da373c05381e6ce8ff94d76f?chain=berachain_mainnet",
      "name": "SolvBTC.BNB-SolvBTC-2%",
      "protocol": "kodiak",
      "symbol": "KODI SolvBTC.BNB-SolvBTC",
      "type": "amm"
    },
    "slug": "kodiak-solvbtc.bnb-solvbtc-2-percent",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5e308fef758278c1f8b626f5c297912094dbe21d",
    "depositTokenAddress": "0xe21efa586cc88271c8c87642440ed49ccd000ccc",
    "matchedToken": {
      "address": "0xe21efa586cc88271c8c87642440ed49ccd000ccc",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/solvbtc-bnb-xsolvbtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xe21efa586cc88271c8c87642440ed49ccd000ccc?chain=berachain_mainnet",
      "name": "SolvBTC.BNB-xSolvBTC",
      "protocol": "kodiak",
      "symbol": "KODI SolvBTC.BNB-xSolvBTC",
      "type": "amm"
    },
    "slug": "kodiak-solvbtc.bnb-xsolvbtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4631251c4d6ed18982401b39446aa21818cc1e10",
    "depositTokenAddress": "0x8b161685135e9fbc5475169e1addc0f2c4b7c343",
    "matchedToken": {
      "address": "0x8b161685135e9fbc5475169e1addc0f2c4b7c343",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/stbgt-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x8b161685135e9fbc5475169e1addc0f2c4b7c343?chain=berachain_mainnet",
      "name": "stBGT-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI stBGT-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-stbgt-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x6c4b82b3f10b3d2fc74b0e560327f29181eec522",
    "depositTokenAddress": "0x7cebcc76a2faecc0ae378b340815fcbb71ec1fe0",
    "matchedToken": {
      "address": "0x7cebcc76a2faecc0ae378b340815fcbb71ec1fe0",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/susda-usda.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x7cebcc76a2faecc0ae378b340815fcbb71ec1fe0?chain=berachain_mainnet",
      "name": "sUSDa-USDa",
      "protocol": "kodiak",
      "symbol": "KODI sUSDa-USDa",
      "type": "amm"
    },
    "slug": "kodiak-susda-usda",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd042c637765fdacebfbafe553d8e78d8d1179fb1",
    "depositTokenAddress": "0xd5b6ea3544a51bfdda7e6926bdf778339801dfe8",
    "matchedToken": {
      "address": "0xd5b6ea3544a51bfdda7e6926bdf778339801dfe8",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/susde-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xd5b6ea3544a51bfdda7e6926bdf778339801dfe8?chain=berachain_mainnet",
      "name": "sUSDe-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI sUSDe-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-susde-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd3b4c14d7eb1701271ffe67ac4e2074c873027cb",
    "depositTokenAddress": "0x28a54eaeec63fbb1175d13466a9ada5f3175d577",
    "matchedToken": {
      "address": "0x28a54eaeec63fbb1175d13466a9ada5f3175d577",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/usdbr-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x28a54eaeec63fbb1175d13466a9ada5f3175d577?chain=berachain_mainnet",
      "name": "USDbr-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI USDbr-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-usdbr-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x14ca51d6aeb70edd1fb1ed7a1aef9f26846786a9",
    "depositTokenAddress": "0xb73dee52f38539ba854979eab6342a60dd4c8c03",
    "matchedToken": {
      "address": "0xb73dee52f38539ba854979eab6342a60dd4c8c03",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 7,
      "image": "/assets/tokens/usdc-e-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xb73dee52f38539ba854979eab6342a60dd4c8c03?chain=berachain_mainnet",
      "name": "USDC.e-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI USDC.e-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-usdc.e-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x197fbf0532b1843d4c077c0c53e58d5ac000ce35",
    "depositTokenAddress": "0xe5a2ab5d2fb268e5ff43a5564e44c3309609aff9",
    "matchedToken": {
      "address": "0xe5a2ab5d2fb268e5ff43a5564e44c3309609aff9",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/usde-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xe5a2ab5d2fb268e5ff43a5564e44c3309609aff9?chain=berachain_mainnet",
      "name": "USDe-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI USDe-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-usde-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xeb9021c012b483216acc9cc0a420096979e007b3",
    "depositTokenAddress": "0x217b9476ecd8783c59ed0ed64c359b8f2b9ccd3a",
    "matchedToken": {
      "address": "0x217b9476ecd8783c59ed0ed64c359b8f2b9ccd3a",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wbera-aibera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x217b9476ecd8783c59ed0ed64c359b8f2b9ccd3a?chain=berachain_mainnet",
      "name": "WBERA-AIBERA",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-AIBERA",
      "type": "amm"
    },
    "slug": "kodiak-wbera-aibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x453da37ac90e968064bd2904b110a1b44e30bc02",
    "depositTokenAddress": "0x2bdb8c39a3808eb9a03de69925b6b158a57c57e6",
    "matchedToken": {
      "address": "0x2bdb8c39a3808eb9a03de69925b6b158a57c57e6",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/wbera-avl.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x2bdb8c39a3808eb9a03de69925b6b158a57c57e6?chain=berachain_mainnet",
      "name": "WBERA-AVL",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-AVL",
      "type": "amm"
    },
    "slug": "kodiak-wbera-avl",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x777b9405775ed87681735e5e88b9d764b142c41e",
    "depositTokenAddress": "0x2cafe99db26cf86ae8587f5934830d25ad5c3cb3",
    "matchedToken": {
      "address": "0x2cafe99db26cf86ae8587f5934830d25ad5c3cb3",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 6,
      "image": "/assets/tokens/wbera-bitcoin.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x2cafe99db26cf86ae8587f5934830d25ad5c3cb3?chain=berachain_mainnet",
      "name": "WBERA-BITCOIN",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-BITCOIN",
      "type": "amm"
    },
    "slug": "kodiak-wbera-bitcoin",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x070d7ecb162aa7a8eed4d328b8ef69c13f1eb845",
    "depositTokenAddress": "0x56449b16ff2b1e5ee61f532ceffda8f408f718a1",
    "matchedToken": {
      "address": "0x56449b16ff2b1e5ee61f532ceffda8f408f718a1",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-br.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x56449b16ff2b1e5ee61f532ceffda8f408f718a1?chain=berachain_mainnet",
      "name": "WBERA-BR",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-BR",
      "type": "amm"
    },
    "slug": "kodiak-wbera-br",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xcf18318580549a5bcd379c50227f1f2bb75dd9fb",
    "depositTokenAddress": "0x68cac522833f38e088eec5e356956c02f0268063",
    "matchedToken": {
      "address": "0x68cac522833f38e088eec5e356956c02f0268063",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-grq.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x68cac522833f38e088eec5e356956c02f0268063?chain=berachain_mainnet",
      "name": "WBERA-GRQ",
      "protocol": "kodiak",
      "symbol": "UNI-V2",
      "type": "amm"
    },
    "slug": "kodiak-wbera-grq",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x418d63947889e55c16280cb7785cf84ef081f224",
    "depositTokenAddress": "0x4a254b11810b8ebb63c5468e438fc561cb1bb1da",
    "matchedToken": {
      "address": "0x4a254b11810b8ebb63c5468e438fc561cb1bb1da",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x4a254b11810b8ebb63c5468e438fc561cb1bb1da?chain=berachain_mainnet",
      "name": "WBERA-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-wbera-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5f044b3bf3fa10d51ab157998c70d07807baf5c4",
    "depositTokenAddress": "0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4",
    "matchedToken": {
      "address": "0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-ibera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4?chain=berachain_mainnet",
      "name": "WBERA-iBERA",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-iBERA",
      "type": "amm"
    },
    "slug": "kodiak-wbera-ibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xe1897e3eb930aad6f9ea9ecf96ea846b5d23b0a6",
    "depositTokenAddress": "0x564f011d557aad1ca09bfc956eb8a17c35d490e0",
    "matchedToken": {
      "address": "0x564f011d557aad1ca09bfc956eb8a17c35d490e0",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/wbera-ibgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x564f011d557aad1ca09bfc956eb8a17c35d490e0?chain=berachain_mainnet",
      "name": "WBERA-iBGT",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-iBGT",
      "type": "amm"
    },
    "slug": "kodiak-wbera-ibgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x6583e71778a3d275b8a27f1252a125f7a6f875d1",
    "depositTokenAddress": "0x9f6cf7acb2f16f7d906eeecb0a6020a5cf91a41d",
    "matchedToken": {
      "address": "0x9f6cf7acb2f16f7d906eeecb0a6020a5cf91a41d",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-lair.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x9f6cf7acb2f16f7d906eeecb0a6020a5cf91a41d?chain=berachain_mainnet",
      "name": "WBERA-LAIR",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-LAIR",
      "type": "amm"
    },
    "slug": "kodiak-wbera-lair",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x0b55d00faae6eeed3311ae40968fe8e22716cce7",
    "depositTokenAddress": "0x337ef1eb6c8bbed571170fc2b468608ab9e2aac8",
    "matchedToken": {
      "address": "0x337ef1eb6c8bbed571170fc2b468608ab9e2aac8",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/wbera-lbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x337ef1eb6c8bbed571170fc2b468608ab9e2aac8?chain=berachain_mainnet",
      "name": "WBERA-LBGT",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-LBGT",
      "type": "amm"
    },
    "slug": "kodiak-wbera-lbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xacb6fa1be2b235474ac5b0c175b2a16189d4d103",
    "depositTokenAddress": "0xd6620e78b89e8fdb5dfa675d55001c7fad424bdc",
    "matchedToken": {
      "address": "0xd6620e78b89e8fdb5dfa675d55001c7fad424bdc",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-pollen.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xd6620e78b89e8fdb5dfa675d55001c7fad424bdc?chain=berachain_mainnet",
      "name": "WBERA-POLLEN",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-POLLEN",
      "type": "amm"
    },
    "slug": "kodiak-wbera-pollen",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd07f2e659b91607758041d85721700debb6cc4b9",
    "depositTokenAddress": "0x93a913351cae2d8c82c4b85f699726947eb76d32",
    "matchedToken": {
      "address": "0x93a913351cae2d8c82c4b85f699726947eb76d32",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/wbera-ramen.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x93a913351cae2d8c82c4b85f699726947eb76d32?chain=berachain_mainnet",
      "name": "WBERA-RAMEN",
      "protocol": "kodiak",
      "symbol": "KODI WBERA-RAMEN",
      "type": "amm"
    },
    "slug": "kodiak-wbera-ramen",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x50a2cc8e872b0d108cb74cd412f7806b262b7fd9",
    "depositTokenAddress": "0x38920562047280f2f95b7aba7a9eaa8d0ae04a5c",
    "matchedToken": {
      "address": "0x38920562047280f2f95b7aba7a9eaa8d0ae04a5c",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wbera-usdc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x38920562047280f2f95b7aba7a9eaa8d0ae04a5c?chain=berachain_mainnet",
      "name": "WBERA-USDC",
      "protocol": "kodiak",
      "symbol": "CHRM WBERA-USDC",
      "type": "amm"
    },
    "slug": "kodiak-wbera-usdc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5c5fcb568a98da28c9d2df4852b102aa814c3a4c",
    "depositTokenAddress": "0xfc4994e0a4780ba7536d7e79611468b6bde14cae",
    "matchedToken": {
      "address": "0xfc4994e0a4780ba7536d7e79611468b6bde14cae",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-ebtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xfc4994e0a4780ba7536d7e79611468b6bde14cae?chain=berachain_mainnet",
      "name": "WBTC-eBTC",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-eBTC",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-ebtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x49ccb2fea875beb68c7f010193990105ea84f384",
    "depositTokenAddress": "0xf6b16e73d3b0e2784aae8c4cd06099be65d092bf",
    "matchedToken": {
      "address": "0xf6b16e73d3b0e2784aae8c4cd06099be65d092bf",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xf6b16e73d3b0e2784aae8c4cd06099be65d092bf?chain=berachain_mainnet",
      "name": "WBTC-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5969494e13e8fa51f8223152a86f14c02860afd3",
    "depositTokenAddress": "0x3879451f4f69f0c2d37cad45319cff2e7d29c596",
    "matchedToken": {
      "address": "0x3879451f4f69f0c2d37cad45319cff2e7d29c596",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-solvbtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x3879451f4f69f0c2d37cad45319cff2e7d29c596?chain=berachain_mainnet",
      "name": "WBTC-SolvBTC",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-SolvBTC",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-solvbtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x55a53d205b16101a15bb8733b6789a771cbea918",
    "depositTokenAddress": "0xb67d60fc02e0870eddca24d4fa8ea516c890152b",
    "matchedToken": {
      "address": "0xb67d60fc02e0870eddca24d4fa8ea516c890152b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-unibtc.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xb67d60fc02e0870eddca24d4fa8ea516c890152b?chain=berachain_mainnet",
      "name": "WBTC-uniBTC",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-uniBTC",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-unibtc",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8ea5f10e039c718e9991108e795cdc154c3008a9",
    "depositTokenAddress": "0xf06ea29fcf4765200742d29e685973a1870eac98",
    "matchedToken": {
      "address": "0xf06ea29fcf4765200742d29e685973a1870eac98",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xf06ea29fcf4765200742d29e685973a1870eac98?chain=berachain_mainnet",
      "name": "WBTC-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x87105154a3e53c719db1289e95dfe15d78ac4de7",
    "depositTokenAddress": "0x58fdb6eebf7df7ce4137994436fb0e629bb84b84",
    "matchedToken": {
      "address": "0x58fdb6eebf7df7ce4137994436fb0e629bb84b84",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/wbtc-weth.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x58fdb6eebf7df7ce4137994436fb0e629bb84b84?chain=berachain_mainnet",
      "name": "WBTC-WETH",
      "protocol": "kodiak",
      "symbol": "KODI WBTC-WETH",
      "type": "amm"
    },
    "slug": "kodiak-wbtc-weth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xfbc99d74cc43cf12eb6b78eddcc2266ff729be19",
    "depositTokenAddress": "0x03bccf796cdef61064c4a2effdd21f1ac8c29e92",
    "matchedToken": {
      "address": "0x03bccf796cdef61064c4a2effdd21f1ac8c29e92",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weth-beraeth.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x03bccf796cdef61064c4a2effdd21f1ac8c29e92?chain=berachain_mainnet",
      "name": "WETH-beraETH",
      "protocol": "kodiak",
      "symbol": "KODI WETH-beraETH",
      "type": "amm"
    },
    "slug": "kodiak-weth-beraeth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xedc856c76acbbcb765ee665e62a639d4d13018f6",
    "depositTokenAddress": "0xf6c6be0ff6d6f70a04dbe4f1ade62cb23053bd95",
    "matchedToken": {
      "address": "0xf6c6be0ff6d6f70a04dbe4f1ade62cb23053bd95",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weth-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xf6c6be0ff6d6f70a04dbe4f1ade62cb23053bd95?chain=berachain_mainnet",
      "name": "WETH-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI WETH-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-weth-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x973129385f7231e8b71797a94ede51f406eb17bf",
    "depositTokenAddress": "0x97431f104be73fc0e6fc731ce84486da05c48871",
    "matchedToken": {
      "address": "0x97431f104be73fc0e6fc731ce84486da05c48871",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weth-stone.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x97431f104be73fc0e6fc731ce84486da05c48871?chain=berachain_mainnet",
      "name": "WETH-STONE",
      "protocol": "kodiak",
      "symbol": "KODI WETH-STONE",
      "type": "amm"
    },
    "slug": "kodiak-weth-stone",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x33e53c508ecfbf6db7b07ac3a36079fbfa919352",
    "depositTokenAddress": "0x9659dc8c1565e0bd82627267e3b4eed1a377ebe6",
    "matchedToken": {
      "address": "0x9659dc8c1565e0bd82627267e3b4eed1a377ebe6",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weth-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x9659dc8c1565e0bd82627267e3b4eed1a377ebe6?chain=berachain_mainnet",
      "name": "WETH-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI WETH-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-weth-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x16ed36cb22b298085d10b119030408c7bbffc24e",
    "depositTokenAddress": "0xa0cabfc04fc420b3d31ba431d18eb5bd33b3f334",
    "matchedToken": {
      "address": "0xa0cabfc04fc420b3d31ba431d18eb5bd33b3f334",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weth-weeth.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xa0cabfc04fc420b3d31ba431d18eb5bd33b3f334?chain=berachain_mainnet",
      "name": "WETH-weETH",
      "protocol": "kodiak",
      "symbol": "KODI WETH-weETH",
      "type": "amm"
    },
    "slug": "kodiak-weth-weeth",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd261979962cd05518994751e29a7600c3869ff89",
    "depositTokenAddress": "0x939fb917bf8579c959094364708ef03f17e71f25",
    "matchedToken": {
      "address": "0x939fb917bf8579c959094364708ef03f17e71f25",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 7,
      "image": "/assets/tokens/xusd-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x939fb917bf8579c959094364708ef03f17e71f25?chain=berachain_mainnet",
      "name": "xUSD-HONEY",
      "protocol": "kodiak",
      "symbol": "KODI xUSD-HONEY",
      "type": "amm"
    },
    "slug": "kodiak-xusd-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x08dd1cc722a47af7a6b4f4f347ff19467af96001",
    "depositTokenAddress": "0x5347e5133b22a680ee94b7e62803e848f8d8c92e",
    "matchedToken": {
      "address": "0x5347e5133b22a680ee94b7e62803e848f8d8c92e",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ybgt-ybera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x5347e5133b22a680ee94b7e62803e848f8d8c92e?chain=berachain_mainnet",
      "name": "yBGT-yBERA",
      "protocol": "kodiak",
      "symbol": "KODI yBGT-yBERA",
      "type": "amm"
    },
    "slug": "kodiak-ybgt-ybera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x6fa248860b38c60874ca414ac89e95b540d52fa5",
    "depositTokenAddress": "0xec8ba456b4e009408d0776cde8b91f8717d13fa1",
    "matchedToken": {
      "address": "0xec8ba456b4e009408d0776cde8b91f8717d13fa1",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/yeet-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.01,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xec8ba456b4e009408d0776cde8b91f8717d13fa1?chain=berachain_mainnet",
      "name": "YEET-WBERA",
      "protocol": "kodiak",
      "symbol": "KODI YEET-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-yeet-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x1b7e10ef6a29add96ea3024e27a28f7cb6b4f609",
    "depositTokenAddress": "0x412c9f79779ae6c3a13a318252b29c559be756ca",
    "matchedToken": {
      "address": "0x412c9f79779ae6c3a13a318252b29c559be756ca",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/yeet-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x412c9f79779ae6c3a13a318252b29c559be756ca?chain=berachain_mainnet",
      "name": "YEET-wgBERA",
      "protocol": "kodiak",
      "symbol": "KODI YEET-wgBERA",
      "type": "amm"
    },
    "slug": "kodiak-yeet-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x63c25e7f9decfa9e161e9232c9c6cf8c4f456b96",
    "depositTokenAddress": "0xabcea3ead918c3c5eca9b85d25b5e463a35a5e66",
    "matchedToken": {
      "address": "0xabcea3ead918c3c5eca9b85d25b5e463a35a5e66",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/zero-ibgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0xabcea3ead918c3c5eca9b85d25b5e463a35a5e66?chain=berachain_mainnet",
      "name": "ZERO-iBGT",
      "protocol": "kodiak",
      "symbol": "KODI ZERO-iBGT",
      "type": "amm"
    },
    "slug": "kodiak-zero-ibgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x50684d5fda2182ac14f3c11f98311a6bfdc4277d",
    "depositTokenAddress": "0x091e41545e4a82e08f35bb51850e905537ced72e",
    "matchedToken": {
      "address": "0x091e41545e4a82e08f35bb51850e905537ced72e",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/zero-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x091e41545e4a82e08f35bb51850e905537ced72e?chain=berachain_mainnet",
      "name": "ZERO-wBERA",
      "protocol": "kodiak",
      "symbol": "KODI ZERO-WBERA",
      "type": "amm"
    },
    "slug": "kodiak-zero-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xf40fb879cfcd801c4710aedb48ddf08603290703",
    "depositTokenAddress": "0x273c832797bfda1c0826a786670d041282bd6afc",
    "matchedToken": {
      "address": "0x273c832797bfda1c0826a786670d041282bd6afc",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/krt.svg",
      "isLpToken": false,
      "isSoulbound": true,
      "isUnpriced": true,
      "mintUrl": "https://exchange.kuma.bid/rewards/trade",
      "name": "Kuma Reward Token",
      "protocol": "kuma",
      "symbol": "KRT",
      "type": "unknown"
    },
    "slug": "kuma-reward-token",
    "rewardTokens": []
  },
  {
    "vaultsAddress": "0x75d026f9fd1142b2ae1bc5553bf7b0e3b3171fee",
    "depositTokenAddress": "0xc2605ed80880bd6b1523d52aef8d624ed468a935",
    "matchedToken": {
      "address": "0xc2605ed80880bd6b1523d52aef8d624ed468a935",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/pendle-ibgt.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.pendle.finance/trade/pools/0x02293d88656860a840ed457d38f51e3e6bee8461/zap/lp-wrapper/wrap?chain=bera",
      "name": "Pendle iBGT",
      "protocol": "pendle",
      "symbol": "PENDLE-LPT-WRAPPED",
      "type": "vault"
    },
    "slug": "pendle-ibgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4a6e7d4edf5ecd054fbf7e759506e76a03e6004b",
    "depositTokenAddress": "0xff21f46bc9d78125705eef6efca62f9420cfdb9b",
    "matchedToken": {
      "address": "0xff21f46bc9d78125705eef6efca62f9420cfdb9b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/satsolvbtc-bera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.satlayer.xyz/vaults/restake",
      "name": "satSolvBTC.BERA",
      "protocol": "satlayer",
      "symbol": "satSolvBTC.BERA",
      "type": "vault"
    },
    "slug": "satlayer-satsolvbtc.bera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x4c037191d2c704bff752d35be3df2e382bce5787",
    "depositTokenAddress": "0x0f6f337b09cb5131cf0ce9df3beb295b8e728f3b",
    "matchedToken": {
      "address": "0x0f6f337b09cb5131cf0ce9df3beb295b8e728f3b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 8,
      "image": "/assets/tokens/solvbtc-bera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.solv.finance/bera?network=bera",
      "name": "SolvBTC.BERA",
      "protocol": "solv",
      "symbol": "SolvBTC.BERA",
      "type": "vault"
    },
    "slug": "solv-solvbtc.bera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x9926525895131197b4eea6d7c2c3ee13895756cb",
    "depositTokenAddress": "0xdb78b4166580917c9604f8ddfbea5f49b493845c",
    "matchedToken": {
      "address": "0xdb78b4166580917c9604f8ddfbea5f49b493845c",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/oribgt-oribgtot.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.steer.finance/vault/0xdb78b4166580917c9604f8ddfbea5f49b493845c",
      "name": "oriBGT-oriBGTOT",
      "protocol": "steer",
      "symbol": "STEERUV20",
      "type": "amm"
    },
    "slug": "steer-oribgt-oribgtot",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xfeb68796d48b3f7e307f44a5376a92d0ad79b9ce",
    "depositTokenAddress": "0x30e148a79b898efa1ab1285f5eca71972a7e0ace",
    "matchedToken": {
      "address": "0x30e148a79b898efa1ab1285f5eca71972a7e0ace",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/bsumer.svg",
      "isLpToken": false,
      "isSoulbound": true,
      "isUnpriced": true,
      "mintUrl": "https://app.sumer.money/?chain=80094",
      "name": "bSumer",
      "protocol": "sumer",
      "symbol": "bSumer",
      "type": "vault"
    },
    "slug": "sumer-bsumer",
    "rewardTokens": []
  },
  {
    "vaultsAddress": "0xaf8942fbe04c8f740398b724334b29be1e53111a",
    "depositTokenAddress": "0x9a7d89284520572b3ec41efeba9add65622b301a",
    "matchedToken": {
      "address": "0x9a7d89284520572b3ec41efeba9add65622b301a",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/swbera-osbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.003,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x9a7d89284520572b3ec41efeba9add65622b301a?chain=berachain_mainnet",
      "name": "sWBERA-osBGT",
      "protocol": "kodiak",
      "symbol": "KODI sWBERA-osBGT",
      "type": "amm"
    },
    "slug": "swbera-osbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x295761ebbb094cf0e02380d3e0072aec3f406b21",
    "depositTokenAddress": "0x09d4683d680abf2ecd69f4d6bcbc006abfe9f6ad",
    "matchedToken": {
      "address": "0x09d4683d680abf2ecd69f4d6bcbc006abfe9f6ad",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/swbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://hub.berachain.com/pools/0x09d4683d680abf2ecd69f4d6bcbc006abfe9f6ad00020000000000000000018f/details/",
      "name": "sWBERA-wgBERA",
      "protocol": "bex",
      "symbol": "50sWBERA-50wgBERA-WEIGHTED",
      "type": "amm"
    },
    "slug": "swbera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xb314e0f2d2789139e39d471dfd65989ff5e6df5b",
    "depositTokenAddress": "0x3640587709a387b54b0df555cd651a95a54fa900",
    "matchedToken": {
      "address": "0x3640587709a387b54b0df555cd651a95a54fa900",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/bee-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://wasabee.honeypotfinance.xyz/vault/0x3640587709a387b54b0df555cd651a95a54fa900",
      "name": "BEE-WBERA",
      "protocol": "wasabee",
      "symbol": "IV-WASABEE-7-BEE-WBERA",
      "type": "amm"
    },
    "slug": "wasabee-bee-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x53cda54ae425eeef7c06b607f0b8807b285569dc",
    "depositTokenAddress": "0xe57d868d244d2cf2e9679eaba2a3048e58674565",
    "matchedToken": {
      "address": "0xe57d868d244d2cf2e9679eaba2a3048e58674565",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wbera-ibera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://wasabee.honeypotfinance.xyz/vault/0xe57d868d244d2cf2e9679eaba2a3048e58674565",
      "name": "WBERA-iBERA",
      "protocol": "wasabee",
      "symbol": "IV-WASABEE-3-WBERA-iBERA",
      "type": "amm"
    },
    "slug": "wasabee-wbera-ibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xd429e1fbffbd1e766d3b9a3184bfb7da3de1d806",
    "depositTokenAddress": "0xac04b1abadf214b57f7ade1dd905ab7acac23a6b",
    "matchedToken": {
      "address": "0xac04b1abadf214b57f7ade1dd905ab7acac23a6b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/wbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://wasabee.honeypotfinance.xyz/vault/0xac04b1abadf214b57f7ade1dd905ab7acac23a6b",
      "name": "WBERA-wgBERA",
      "protocol": "wasabee",
      "symbol": "IV-WASABEE-4-WBERA-wgBERA",
      "type": "amm"
    },
    "slug": "wasabee-wbera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5da6e850042ad3bc859674c33f1d230dc1785b9a",
    "depositTokenAddress": "0xec06041013b3a97c58b9ab61eae9079bc594eda3",
    "matchedToken": {
      "address": "0xec06041013b3a97c58b9ab61eae9079bc594eda3",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/weth-wbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://wasabee.honeypotfinance.xyz/vault/0xec06041013b3a97c58b9ab61eae9079bc594eda3",
      "name": "WETH-WBERA",
      "protocol": "wasabee",
      "symbol": "IV-WASABEE-2-WETH-WBERA",
      "type": "amm"
    },
    "slug": "wasabee-weth-wbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x3835ec3a7a46c670cd7226bf55d55e1029bce4f2",
    "depositTokenAddress": "0xd948212f077e552533158becbc1882c1b19c40fe",
    "matchedToken": {
      "address": "0xd948212f077e552533158becbc1882c1b19c40fe",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/shoney.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.wasabi.xyz/earn?vault=shoney&network=berachain",
      "name": "sHONEY",
      "protocol": "wasabi",
      "symbol": "sHONEY",
      "type": "cdp"
    },
    "slug": "wasabi-shoney",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x5d5f805f1b4b7431dd3f286a61a8a5b0f195649d",
    "depositTokenAddress": "0xc95ab9eff8fb48760703c74416764b8f898afa1b",
    "matchedToken": {
      "address": "0xc95ab9eff8fb48760703c74416764b8f898afa1b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/swbera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.wasabi.xyz/earn?vault=swbera&network=berachain",
      "name": "sWBERA",
      "protocol": "wasabi",
      "symbol": "sWBERA",
      "type": "cdp"
    },
    "slug": "wasabi-swbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xa6298fcbdcf56a86feec3cd223157a2ee8ebea63",
    "depositTokenAddress": "0x396a3d0b799b1a0b1eaa17e75b4dea412400860b",
    "matchedToken": {
      "address": "0x396a3d0b799b1a0b1eaa17e75b4dea412400860b",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/weibera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.webera.finance/vault?token=ibera&type=bera-lst",
      "name": "weiBERA",
      "protocol": "webera",
      "symbol": "weiBERA",
      "type": "cdp"
    },
    "slug": "webera-weibera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x399bdbd813a82f34e48680ba85862c07586de3f4",
    "depositTokenAddress": "0x55a050f76541c2554e9dfa3a0b4e665914bf92ea",
    "matchedToken": {
      "address": "0x55a050f76541c2554e9dfa3a0b4e665914bf92ea",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 3,
      "image": "/assets/tokens/wewbera.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "mintUrl": "https://app.webera.finance/vault?token=bera&type=lend/borrow",
      "name": "weWBERA",
      "protocol": "webera",
      "symbol": "weWBERA",
      "type": "cdp"
    },
    "slug": "webera-wewbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x8cea590b8b30de2cdecf96cbaf0113e2390e5ffd",
    "depositTokenAddress": "0x0435c32c79e8341e44047493ba371b502b8c90af",
    "matchedToken": {
      "address": "0x0435c32c79e8341e44047493ba371b502b8c90af",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ewbera-wgbera.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0005,
      "mintUrl": "https://www.winnieswap.com/vaults/0x0435c32c79e8341e44047493ba371b502b8c90af",
      "name": "ewBERA-wgBERA",
      "protocol": "winnieswap",
      "symbol": "STICKY eWBERA-4-wgBERA",
      "type": "amm"
    },
    "slug": "winnieswap-ewbera-wgbera",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xde6a9aacd3c749b3e0a290f65f17a744c9c40215",
    "depositTokenAddress": "0xa5b3ecafbfcc7946c11a28252c6f2bdb73d30388",
    "matchedToken": {
      "address": "0xa5b3ecafbfcc7946c11a28252c6f2bdb73d30388",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 0,
      "image": "/assets/tokens/nect-honey.svg",
      "imageCount": 2,
      "isLpToken": true,
      "kodiakTradingFee": 0.0001,
      "mintUrl": "https://www.winnieswap.com/vaults/0xa5b3ecafbfcc7946c11a28252c6f2bdb73d30388",
      "name": "NECT-HONEY",
      "protocol": "winnieswap",
      "symbol": "STICKY NECT-HONEY",
      "type": "amm"
    },
    "slug": "winnieswap-nect-honey",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x0a693bcf5ac9f02b3fe926d8676758701ca54a4d",
    "depositTokenAddress": "0xd7cfdd9514b6ef10e9cf271cf62955530adbc4ec",
    "matchedToken": {
      "address": "0xd7cfdd9514b6ef10e9cf271cf62955530adbc4ec",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/yeet-rwt.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isSoulbound": true,
      "mintUrl": "https://yeetit.xyz",
      "name": "Yeet",
      "protocol": "yeet",
      "symbol": "YEET-RWT",
      "type": "unknown"
    },
    "slug": "yeet",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0xfacacd8b4452aac5b861ad429727f3b0aeceb446",
    "depositTokenAddress": "0x137bac38316075f6675027592b922a7f95a9dd97",
    "matchedToken": {
      "address": "0x137bac38316075f6675027592b922a7f95a9dd97",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 1,
      "image": "/assets/tokens/yeet-osbgt.svg",
      "imageCount": 2,
      "isLpToken": true,
      "mintUrl": "https://app.kodiak.finance/#/liquidity/pools/0x137bac38316075f6675027592b922a7f95a9dd97?chain=berachain_mainnet",
      "name": "YEET-osBGT",
      "protocol": "yeet",
      "symbol": "KODI YEET-osBGT",
      "type": "amm"
    },
    "slug": "yeet-yeet-osbgt",
    "rewardTokens": [
      {
        "address": "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
        "chainId": 80094,
        "decimals": 18,
        "displayPrecision": 3,
        "image": "/assets/tokens/ibgt.svg",
        "isLpToken": false,
        "name": "iBGT",
        "symbol": "iBGT"
      }
    ]
  },
  {
    "vaultsAddress": "0x388f6b6ced5f685fbadced62ee2c1ecfca34c0cc",
    "depositTokenAddress": "0x4e1d8c85a1061816b22c109b221dead1690f9c00",
    "matchedToken": {
      "address": "0x4e1d8c85a1061816b22c109b221dead1690f9c00",
      "chainId": 80094,
      "decimals": 18,
      "displayPrecision": 2,
      "image": "/assets/tokens/ybb.svg",
      "imageNotFromUnderlying": true,
      "imageCount": 1,
      "isLpToken": false,
      "isSoulbound": true,
      "mintUrl": "https://yeetit.xyz",
      "name": "Yeetarded Buyback",
      "protocol": "yeet",
      "symbol": "YBB",
      "type": "unknown"
    },
    "slug": "yeetarded-buyback",
    "rewardTokens": []
  }
];